import React, { FC } from 'react';
import { RouteDescription, useRouter } from 'shared-routing';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { useTranslations } from '@lang';
import { Button } from '@common/components';

import { spaPackageFormConfig } from './shared';

type NextStepButtonProps = {
  nextUrl: RouteDescription;
  disabled?: boolean;
};

const NextStepButton: FC<NextStepButtonProps & InjectedFormProps<{}, NextStepButtonProps>> = ({
  nextUrl,
  handleSubmit,
  disabled,
}) => {
  const { t } = useTranslations();
  const router = useRouter();

  const moveToNext = (nextUrl: RouteDescription) => () => {
    router.push(nextUrl);
  };
  return (
    <Button onClick={handleSubmit(moveToNext(nextUrl))} isPrimary disabled={disabled}>
      {t('spa.package.nextStep')}
    </Button>
  );
};

export default reduxForm<{}, NextStepButtonProps>(spaPackageFormConfig)(NextStepButton);
